export const nameRules = [
  (v: string) => !!v || 'Поле обязательно',
  (v: string) => (v && v.length >= 12) || 'Название должно быть больше 12 символов',
];

export const domainRules = [
  (v: string[]) => (v && v.length > 0) || 'Необходимо выбрать, как минимум, один сайт',
];
